/* eslint react/prop-types: 0, react/jsx-no-bind: 0, jsx-a11y/no-static-element-interactions: 0 */
import priceFormatter from 'currency-formatter'
import { AccessibleDivComponent } from 'svr/common/A11y'
import * as styles from '../assets/styles/eventOverview'
import QuantityStepper from '../containers/QuantityStepper'
import { connect } from 'react-redux'
import { calcTotalFeePrice } from 'widget/events/utils/calcCharges'

priceFormatter.currencies[0].symbol = 'AED'
priceFormatter.currencies[0].symbolOnLeft = true

export const InventoryItemSmall = ({
  availabilityId,
  inventoryItem,
  inventoryEdits,
  boundToggleInventoryItem,
  selectInventoryItem,
  currencyCode,
  textMinimumSpend,
  isFeesInPriceDisplayed,
  defaultServiceCharge,
  remainingQuantity,
  shouldShowRemainingInventory,
}) => {
  const { price, compText, inventoryId, inventoryType, entryPerReservation } = inventoryItem
  const maxQuantity = Math.min(inventoryItem.maxQuantity, inventoryEdits[inventoryId].remainingQuantity)
  const { isHighlighted } = inventoryEdits[inventoryId]
  const quantity = Math.max(inventoryItem.minQuantity, inventoryEdits[inventoryId].quantity)
  const basePrice = price * quantity

  const totalFeePrice = calcTotalFeePrice(inventoryItem, quantity, price, defaultServiceCharge)
  const totalPrice = isFeesInPriceDisplayed ? basePrice + totalFeePrice : basePrice

  const numGuests = quantity * entryPerReservation
  const minDollarText = (function () {
    if (!inventoryItem.minPrice) {
      return ''
    }
    const minDollarAmount = quantity * inventoryItem.minPrice
    const minDollarAmountFormatted = priceFormatter.format(minDollarAmount, {
      code: currencyCode,
    })
    return `, ${minDollarAmountFormatted} ${textMinimumSpend}`
  })()

  let headerText
  if (numGuests === 1) {
    const headerInner = inventoryType === 'RESERVATION' ? `For 1 guest${minDollarText}` : 'For 1 guest'
    headerText = <span>{headerInner}</span>
  } else {
    let headerString
    if (inventoryType === 'RESERVATION') {
      headerString = `Up to ${numGuests} guests${minDollarText}`
    } else if (inventoryType === 'REQUEST') {
      headerString = ''
    } else {
      headerString = `For ${numGuests} guests`
    }
    headerText = <span>{headerString}</span>
  }

  const onInventoryClick = () => {
    if (maxQuantity === 1) {
      selectInventoryItem(inventoryId, availabilityId)
    } else {
      boundToggleInventoryItem(inventoryId)
    }
  }

  let priceText = priceFormatter.format(totalPrice, { code: currencyCode })
  if (inventoryType === 'GUESTLIST_TICKET_FREE') {
    priceText = compText
  } else if (inventoryType === 'REQUEST') {
    priceText = 'Request'
  }

  return (
    <InventoryItemRow
      inventoryName={inventoryItem.inventoryName}
      headerText={headerText}
      priceText={priceText}
      isFeesInPriceDisplayed={isFeesInPriceDisplayed}
      totalFeePrice={totalFeePrice}
      currencyCode={currencyCode}
      onClick={onInventoryClick}
    >
      {isHighlighted && (
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '14px' }}>
          <div>
            {maxQuantity > 1 && (
              <>
                <QuantityStepper
                  inventoryId={inventoryId}
                  quantity={quantity}
                  minQuantity={inventoryItem.minQuantity}
                  maxQuantity={maxQuantity}
                />
                {shouldShowRemainingInventory && <div style={styles.remainingQuantity}>{remainingQuantity} remaining</div>}
              </>
            )}
          </div>
          <AccessibleDivComponent
            aria-label="select inventory"
            onClick={selectInventoryItem.bind(null, inventoryId, availabilityId)}
            style={styles.continueButton}
          >
            continue
          </AccessibleDivComponent>
        </div>
      )}
    </InventoryItemRow>
  )
}
const mapStateToProps = state => {
  const { date, eventId } = state.userSelection.toJS()
  const event = state.entities.events.get(eventId)

  return {
    eventAvailabilities: state.entities.availability.get(date).get(eventId),
    textMinimumSpend: state.widgetSettings.textMinimumSpend,
    shouldShowRemainingInventory: event.get('shouldShowRemainingInventory'),
  }
}
const mergeProps = (stateProps, _dispatchProps, ownProps) => {
  const { inventoryId } = ownProps.inventoryItem
  const eventAvailabilities = stateProps.eventAvailabilities.get(inventoryId)

  return {
    ...stateProps,
    ...ownProps,
    availabilityId: eventAvailabilities.get('availabilityId'),
    remainingQuantity: eventAvailabilities.get('remainingQuantity'),
  }
}
export default connect(mapStateToProps, null, mergeProps)(InventoryItemSmall)

function InventoryItemRow({
  children,
  inventoryName,
  headerText,
  priceText,
  isFeesInPriceDisplayed,
  totalFeePrice,
  currencyCode,
  onClick,
}) {
  return (
    <AccessibleDivComponent
      aria-label="inventory item"
      data-inventory-item-name={inventoryName}
      onClick={onClick}
      style={{ ...styles.inventoryListItem, cursor: 'pointer' }}
    >
      <div style={{ ...styles.tertiaryText, ...styles.textOverflow, margin: '1px 0px 4px' }} data-test="header-text-small">
        {headerText}
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={styles.primaryText}>{inventoryName}</div>
        <div style={{ textAlign: 'right', marginLeft: '12px' }}>
          <div style={styles.secondaryText} data-test="price-text">
            {priceText}
          </div>
          {!!(isFeesInPriceDisplayed && totalFeePrice) && (
            <div data-test="fees-in-price" style={styles.tertiaryText}>
              * Includes {priceFormatter.format(totalFeePrice, { code: currencyCode })} in fees
            </div>
          )}
        </div>
      </div>
      {children}
    </AccessibleDivComponent>
  )
}
